import {Types} from '../../Models/InfinityTableModel';
import {InfinityTable as InfinityTableActionTypes} from "Redux/Actions/EnumTypes/ActionEnumTypes";
import {InfinityTableAction} from '../Actions/Models/InfinityTableActionModel';

export type State = Types.InfinityTableStore;

export const initialState: State = {
    isLoading: false,
    count: 0,
    totalCount: null,
    activeId: null
};

export function infinityTableReducer(state: State = initialState, action: InfinityTableAction): State {
    switch (action.type) {
        case InfinityTableActionTypes.SET_COUNT: {
            return {
                ...state,
                count: action.payload.count
            };
        }
        case InfinityTableActionTypes.SET_TOTAL_COUNT: {
            return {
                ...state,
                totalCount: action.payload.totalCount
            };
        }
        case InfinityTableActionTypes.SET_ALL_COUNTS: {
            return {
                ...state,
                count: action.payload.count,
                totalCount: action.payload.totalCount
            };
        }
        case InfinityTableActionTypes.SET_LOADING: {
            return {
                ...state,
                isLoading: action.payload.isLoading
            };
        }
        default: {
            return {
                ...state
            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/Redux/Reducers/InfinityTeableReducer.ts